// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header__1DlzA","PageTitle":"Header__PageTitle__1evbc","HeaderTexts":"Header__HeaderTexts__2BRJM","HeaderTitle":"Header__HeaderTitle__2osoq","RestaurantName":"Header__RestaurantName__2he2o","PageName":"Header__PageName__o2sa3","HeaderTitleNoSteps":"Header__HeaderTitleNoSteps__1rf_E","Steps":"Header__Steps__1pnEZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Header/Header.css
// module id = 205
// module chunks = 0